/**
 * Shared class names per text role on the Library's editorial cards (D8):
 * the resource card, the collection cards and the collection banner read
 * these, so the later extraction into shared components is mechanical.
 * Sentence case everywhere: no uppercase or tracked labels.
 */

/**
 * Card title: the display serif (Sumana by default) in bold, two lines at
 * most. Regular weight on the default Fairgen display font (no
 * custom heading font), where Sumana reads heavy in bold. The bottom padding keeps descenders (g, p, y) inside the clamp's
 * clip on the last line.
 */
export const LIBRARY_CARD_TITLE_CLASS =
  'font-display text-[21px] font-bold [:root:not([data-heading-font])_&]:font-normal leading-[1.22] tracking-[-0.005em] text-foreground line-clamp-2 pb-[0.1em]'

/** The one or two lines under the title. */
export const LIBRARY_CARD_DESCRIPTION_CLASS =
  'text-[14px] leading-[1.5] text-muted-foreground line-clamp-2'

/** The meta row (market, year, kind), dot separated. */
export const LIBRARY_CARD_META_CLASS =
  'flex min-w-0 flex-wrap items-center gap-x-1.5 gap-y-1 text-[13px] text-muted-foreground'

/** A chip laid over a cover (type, brand). Pass to `Badge` as `className`. */
export const LIBRARY_CARD_CHIP_CLASS =
  'rounded-full border-0 px-2.5 py-0.5 text-[12px] font-medium shadow-sm'

/** Chip tone over a photo: dark glass (the media scrim token), readable on any cover. */
export const LIBRARY_CARD_COVER_CHIP_CLASS =
  'bg-media-scrim/70 text-media-scrim-foreground hover:bg-media-scrim/70'

/**
 * The soft shade behind a cover's chips: a short radial from the bottom left
 * corner, so it sits only under the chips and never greys the whole bottom
 * band of a light document cover.
 */
export const LIBRARY_CARD_COVER_SCRIM_CLASS =
  'pointer-events-none absolute bottom-0 left-0 h-24 w-4/5 bg-[radial-gradient(ellipse_at_bottom_left,hsl(var(--media-scrim)/0.32),transparent_70%)]'

/** The cover frame. */
export const LIBRARY_CARD_COVER_CLASS =
  'relative w-full overflow-hidden rounded-[14px] border border-border bg-muted'
